import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { brandColors } from "../../theme";

export const useCustomerRequirementStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        btnContainer: {
            marginTop: theme.spacing(4),
        },
        btn: {
            paddingTop: theme.spacing(1.2),
            paddingBottom: theme.spacing(1.2),
            minWidth: "160px",
            "&:first-child": {
                marginRight: theme.spacing(2),
            },
        },
        btnDark: {
            backgroundColor: theme.palette.grey[900],
            color: theme.palette.common.white,
        },
        scrollableContent: {
            maxHeight: '60vh',
            overflowY: 'auto',
        },
        scrollableContentCustomerList: {
            maxHeight: '60vh',
            overflowY: 'auto',
            padding: '5vh',
        },
    })
);

export const useRequirementPanelStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // width: "100%",
        },
        row: { width: "100%" },
        heading: {
            fontWeight: 500,
        },
        circle: {
            margin: theme.spacing(1),
            width: "12px",
            height: "12px",
            borderRadius: "100%",
        },
        green: {
            backgroundColor: brandColors.success.bright,
        },
        red: {
            backgroundColor: brandColors.secondary.main,
        },
        yellow: {
            backgroundColor: brandColors.primary.main,
        },
        btnAllocation: (props: any) => ({
            marginTop: theme.spacing(2),
            marginBottom: props.showAllocation ? theme.spacing(2) : 0,
        }),
        iconExpand: {
            borderRadius: "100%",
            backgroundColor: theme.palette.grey[50],
            color: theme.palette.primary.main,
            transform: "scale(0.9)",
            ".MuiExpansionPanelSummary-expandIcon.Mui-expanded &": {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
            },
        },
    })
);

export const useRequirementTableStyles = makeStyles((theme: Theme) =>
    createStyles({
        tableContainer: {
            padding: theme.spacing(3),
            paddingTop: 0,
        },
        table: {
            border: `1px solid ${theme.palette.grey[300]}`,
            "& .MuiTableCell-root": {
                border: `1px solid ${theme.palette.grey[300]}`,
                padding: theme.spacing(1),
                ...theme.typography.body2,
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontWeight: 500,
                backgroundColor: "#FFF0F2",
            },
        },
        tableRowTitle: {
            flexDirection: "row",
            backgroundColor: theme.palette.common.white,
        },
        greyBackground: { backgroundColor: theme.palette.grey[50] },
        green: { backgroundColor: brandColors.success.bgAlt },
        red: { backgroundColor: brandColors.secondary.bg },
        yellow: { backgroundColor: brandColors.primary.light },
        flex: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        rowTitle: {
            fontWeight: 500,
        },
        btnAllocation: {
            width: theme.spacing(17),
            marginLeft: theme.spacing(2),
        },
        collapseRow: {
            backgroundColor: theme.palette.common.white,
        },
    })
);
